import { formPostRequest, jsonPostRequest } from '@/plugin/axios/commonApi'
import request from '@/plugin/axios'

export function listDictByType (params) {
  return jsonPostRequest('/student/dict/listByType', params)
}

export function listAllCourse () {
  return jsonPostRequest('/student/course/listAll')
}

export function findCourse (params) {
  return jsonPostRequest('/student/course/find', params)
}

export function findNotice () {
  return jsonPostRequest('/student/notice/find')
}

export function getAuthorizationUrl (params) {
  return formPostRequest('/sso/authorizationUrl/student', params)
}

export function ssoLogin (ssoCode) {
  return formPostRequest('/sso/student/login', { ssoCode })
}

export function refreshJwtToken (refreshToken) {
  return formPostRequest('/sso/refreshToken', { refreshToken })
}

export function uploadFile (file, fileType) {
  const formData = new window.FormData()
  formData.append('file', file)
  formData.append('fileType', fileType)
  return request({
    url: '/student/file/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data;'
    }
  })
}

export function getFile (file) {
  return request({
    method: 'get',
    url: 'student/file/download?id=' + file.id,
    responseType: 'blob'
  })
}

export function getFileByFileUrl (file) {
  return request({
    method: 'get',
    url: 'student/file/downloadByFileUrl?fileUrl=' + file.fileUrl,
    responseType: 'blob'
  })
}

export function listCert (params) {
  return jsonPostRequest('/student/cert/list', params)
}

export function getChargeConfig (params) {
  return jsonPostRequest('/student/chargeConfig/findByChargeType', params)
}

export function getBankTransferConfig () {
  return jsonPostRequest('/student/bankTransferInfo/getConfig')
}

export function downloadFile (file) {
  return getFile(file).then(res => {
    if (!res) return
    const downloadUrl = window.URL.createObjectURL(new Blob([res]))
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = downloadUrl
    link.setAttribute('download', file.fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
}

export function getHolidayListFromToday () {
  return jsonPostRequest('/student/holidayConfig/dateListFromToday')
}
